import {
  parseCheckoutError
} from "./chunk-WWLG26XU.mjs";
import {
  fetchClient
} from "./chunk-SKVXOXWB.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/booking/checkout.ts
import { getItem, getLocaleOnly } from "@wbk/utils";
import { CheckoutException } from "@wbk/logger";
var hyCheckout = (_0) => __async(void 0, [_0], function* ({ order, sta, locale, email }) {
  var _a, _b, _c, _d;
  try {
    const lang = getLocaleOnly(locale);
    const url = sta ? "vs/bookings/create" : "book/get_payment_url";
    const app_source = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource;
    const savedUtms = getItem("utms");
    const utm = savedUtms ? JSON.parse(savedUtms) : null;
    const data = yield fetchClient({
      url: `${url}?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadProps(__spreadValues({}, order), { app_source, lang }), utm))
      }
    });
    if (((_c = data == null ? void 0 : data.status) == null ? void 0 : _c.toLowerCase()) !== "success") {
      const possibleErrors = data.error || {};
      const msg = typeof possibleErrors === "string" ? possibleErrors : (_d = Object.values(possibleErrors)) == null ? void 0 : _d[0];
      const msgString = Array.isArray(msg) ? msg[0] : msg;
      throw new Error(msgString || "Something went wrong");
    }
    return data;
  } catch (error) {
    const err = error;
    const possibleTicketErrors = parseCheckoutError(err);
    throw new CheckoutException({
      error: err,
      order: __spreadProps(__spreadValues({}, order), { email }),
      ticketErrors: possibleTicketErrors
    });
  }
});

export {
  hyCheckout
};
//# sourceMappingURL=chunk-E4XMY3JC.mjs.map